import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section id="inicio" className="relative bg-[#5a4579] text-white min-h-screen lg:min-h-[90vh] flex items-center pt-20 pb-8 lg:pt-20 lg:pb-0 overflow-hidden" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-197">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-198">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="max-w-2xl text-center lg:text-left" data-id="element-199">
            <p className="text-inkova-accent text-sm md:text-base font-bold tracking-[0.3em] uppercase mb-4" data-id="element-200">
              Ver · Creer · Crear
            </p>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white font-serif" data-id="element-201">
              ¿Cuánto tiempo llevas pensando en crear tu negocio
              en&nbsp;Estados&nbsp;Unidos?
            </h1>

            <p className="text-base sm:text-xl md:text-2xl text-inkova-accent italic font-light mb-6" data-id="element-202">
              Si la respuesta es "más del que debería"… esto es
              exactamente&nbsp;para&nbsp;ti.
            </p>

            <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-8 lg:mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0 font-sans font-light" data-id="element-203">
              Acompañamos a emprendedores latinos dentro y fuera de USA a crear
              su empresa con orden, estructura y presencia digital —
              sin&nbsp;perderse&nbsp;en&nbsp;el&nbsp;camino.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-204">
              <a href="#reserva" className="inline-flex justify-center items-center px-8 py-4 rounded-full bg-inkova-accent text-inkova-primary font-semibold text-base sm:text-lg hover:bg-white transition-colors duration-300 shadow-lg w-full sm:w-auto" data-id="element-205">
                Reserva sesión estratégica
              </a>
              <p className="text-sm text-gray-300 mt-2" data-id="element-206">
                ¿Tienes dudas primero?{' '}
                <a href="https://wa.me/17863037695" target="_blank" rel="noopener noreferrer" className="text-inkova-accent hover:underline font-medium" data-id="element-207">
                  Escríbenos por WhatsApp →
                </a>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.4
        }} className="flex items-center justify-center order-first lg:order-last" data-id="element-208">
            <img src="https://cdn.magicpatterns.com/uploads/92Zgbj9dykCv9maWxyCKmk/INK_PNG.png" alt="Inkova — Business Consulting & Creation" className="w-full max-w-md lg:max-w-lg h-auto object-contain" data-id="element-209" />
          </motion.div>
        </div>
      </div>
    </section>;
}